import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Loading } from '@components';
// import '@style/modules/analysis/powerbi.scss';
import '../../styles/modules/analysis/powerbi.scss';
import { getUserGuideRequest } from '@service/apis';
import {
  PDFDownload,
  PDFTitle,
} from '@components/hubModule/pdfTitleAndDownload';
import { filterXSS } from 'xss';

const modalContainer = () => document.querySelector('.app-body');

export const UserguidModal = ({ isModalVisible, toggleModalVisible, url }) => (
  <Modal
    getContainer={modalContainer}
    closeIcon={<div className="appkiticon icon-close-fill" />}
    style={{ top: 0, zoom: 1.25 }}
    footer={null}
    className="hub-powerbi-embed-wrapper"
    visible={isModalVisible}
    onCancel={() => toggleModalVisible(false)}
    zIndex={1001}
  >
    <Content visible={isModalVisible} url={url} />
  </Modal>
);

const Content = () => {
  const [pdfContent, setPdfContent] = useState(null);

  useEffect(() => {
    (async () => {
      const { fileName, data } = await getUserGuideRequest('share');

      setPdfContent({ contentBlob: data, fileName });
    })();

    return () => {
      URL.revokeObjectURL(pdfContent);
    };
  }, []);

  return (
    <div className="page-wrapper integration-hub-iframe-page project">
      <div className="integration-hub-user-guid">User Guide</div>

      <div className="guide-wrapper" style={{ position: 'relative' }}>
        {pdfContent ? (
          <div style={{ position: 'relative', height: '100%' }}>
            <PDFTitle pdfContent={pdfContent} />
            <PDFDownload pdfContent={pdfContent} />
            <iframe
              style={{ paddingTop: '1.875rem !important' }}
              title="inte-iframe"
              src={`${filterXSS(URL.createObjectURL(pdfContent.contentBlob))}`}
            />
          </div>
        ) : (
          <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
        )}
      </div>
    </div>
  );
};
